export default __webpack_public_path__ + "static/media/ico-faq.02adba0b.webp";